document.addEventListener('DOMContentLoaded', function() {
    function initCarousels() {
        const carouselConts = document.querySelectorAll(".col-sliders");

        const slideEl = document.querySelector(".col-sliders__slider .productgrid--item");
        let slideWidth = slideEl.offsetWidth;

        // Add resize handler
        window.addEventListener('resize', () => {
            slideWidth = slideEl.offsetWidth;
        });
        
        carouselConts.forEach(el => {
            const carousel = el.querySelector(".col-sliders__slider"),
                  next = el.querySelector(".col-sliders__arrow.--next"),
                  prev = el.querySelector(".col-sliders__arrow.--prev");

            next.addEventListener("click", () => navigate("forward", carousel));
            prev.addEventListener("click", () => navigate("backward", carousel));
        });

        // // Add keyboard handlers
        // document.addEventListener('keydown', (e) => {
        //     if (e.code === 'ArrowLeft') {
        //         clearInterval(autoplay);
        //         navigate("backward");
        //     } else if (e.code === 'ArrowRight') {
        //         clearInterval(autoplay);
        //         navigate("forward");
        //     }
        // });

         // Slide transition
        const getNewScrollPosition = (arg, carousel) => {
            const gap = 32;
            const maxScrollLeft = carousel.scrollWidth - (slideWidth * 3 + gap * 2);

            if (arg === "forward") {
                const x = carousel.scrollLeft + slideWidth + gap;

                return x <= maxScrollLeft ? x : 0;
            } 
            else if (arg === "backward") {
                const x = carousel.scrollLeft - slideWidth - gap;
                return x >= 0 ? x : maxScrollLeft;
            } 
            // else if (typeof arg === "number") {
            //     const x = arg * (slideWidth + gap);
            //     return x;
            // }
        }
        const navigate = (arg, carousel) => {
            carousel.scrollLeft = getNewScrollPosition(arg, carousel);
        }
    }
    initCarousels();
});